<template>
  <div class="loginBody login_bg">
    <div class="login">
      <div class="message">管理员登录</div>
      <div id="darkbannerwrap"></div>
      <form class="layui-form" id="form1">
        <div v-if="!is_qrcode">
          <input v-model="login_name" placeholder="请输入邮箱" type="text" class="layui-input" autocomplete="off" id="username" lay-verify="required">
          <hr class="hr15">
          <input v-model="password" name="password" placeholder="请输入授权码" type="password" class="layui-input" autocomplete="off" id="password" lay-verify="required">
          <hr class="hr15">
        </div>
        <div class="qrcode-wrapper" v-else>
          <img :src="qrcode_url" alt="">
        </div>
        <div class="qrcode">
          <span @click="showPassword" v-if="is_qrcode">邮箱登录</span>
          <span @click="showQrcode" v-if="!is_qrcode">扫码登录</span>
        </div>
        <hr class="hr15" v-if="!is_qrcode">
        <span class="layui-btn loginin" v-if="!is_qrcode" @click="login">{{ loginStatus ? "登 录 中..." : '登 录' }}</span>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loginStatus: false, //true 登录中
      login_name: "",
      password: "",
      is_qrcode: true,
      time: 3600,
      qrcode_url: '/api/oauth/login',
      interval: false,
    };
  },
  methods: {
    login() {
      if (this.loginStatus) {
        return;
      }
      if (this.login_name == "" || this.password == "") {
        this.$util.msg("请输入用户名或密码");
      } else {
        this.loginStatus = true;
        this.$ajax({
          type: "post",
          url: "/admin/login",
          data: {
            email: this.login_name,
            password: this.password
          }
        })
        .then(data => {
          this.loginStatus = false;
          if(data.code != 200) {
            return this.$util.msg(data.msg, "error");
          }

          this.$util.msg(data.msg, "success");

          if(this.interval) {
            clearInterval(this.interval);
          }

          setTimeout(() => {
            this.loginStatus = false;
            sessionStorage.setItem("token", data.data.token);
            // 这里处理一下. 看能不能根据信息来获取一下.
            sessionStorage.setItem("username", this.login_name);
            sessionStorage.setItem('is_bind', data.data.is_bind);
            sessionStorage.setItem('is_set', data.data.is_set);
            this.$router.push({ path: "/" });
          }, 1200);
        })
        .catch(error => {
          this.loginStatus = false;
        });
      }
    },
    refershQrcode() {
      setInterval(() => {
        let time = this.time,
          qrcode_url = '/api/oauth/login';

        time--;

        if(time <= 0) {
          qrcode_url = qrcode_url + '?t=_' + Date.now(),
          time = 3600;
        }

        this.time = time;
        this.qrcode_url = qrcode_url;
      }, 1000);
    },

    checkQrcode() {
      this.interval = setInterval(() => {
        this.$ajax({
          type: "GET",
          url: "/oauth/check",
        }).then((res) => {
          if(res.code == -304) {
            // 这里要刷新.
            return this.qrcode_url = '/api/oauth/login?t=_' + Date.now();
          }

          if(res.code == 200) {
            clearInterval(this.interval);
            this.$util.msg(res.msg, "success");
            setTimeout(() => {
              this.loginStatus = false;
              sessionStorage.setItem("token", res.data.token);
              // 这里处理一下. 看能不能根据信息来获取一下.
              sessionStorage.setItem("username", res.data.email);
              sessionStorage.setItem('is_bind', res.data.is_bind);
              sessionStorage.setItem('is_set', res.data.is_set);
              this.$router.push({ path: "/" });
            }, 1200);
          }
          
          return;
        });
      }, 1000);
    },

    showQrcode() {
      this.is_qrcode = true;
    },

    showPassword() {
      this.is_qrcode = false;
    },
  },
  created() {
    this.$store.commit("setIsOut", false);
    document.onkeydown = e => {
      if (e.keyCode == 13) {
        this.login();
      }
    };

    this.refershQrcode();
    this.checkQrcode();
  },
  destroyed() {
    document.onkeydown = e => {
      if (e.keyCode == 13) {
        return false;
      }
    };
  }
};
</script>
<style scoped>
.login_bg {
  height: 100%;
  background: url(../assets/images/bg.jpg) no-repeat center;
  background-size: cover;
  overflow: hidden;
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  /* height: 420px; */
  height: 390px;
  max-width: 420px;
  padding: 40px;
  background-color: #ffffff;
  margin-left: auto;
  margin-right: auto;
  border-radius: 4px;
  /* overflow-x: hidden; */
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.login a.logo {
  display: block;
  height: 58px;
  width: 167px;
  margin: 0 auto 30px auto;
  background-size: 167px 42px;
}

.qrcode-wrapper {
  text-align: center;
}

.qrcode-wrapper img{
  max-width: 100%;
  height: 230px;
}

.login .message {
  margin: 0 0 0 -58px;
  padding: 20px 10px 20px 60px;
  background-color: #304156;
  background-repeat: repeat-y;
  background: -moz-linear-gradient(to right, #1890FF, #304156);
  background: -webkit-linear-gradient(to right, #1890FF, #304156);
  background: -o-linear-gradient(to right, #1890FF, #304156);
  background: linear-gradient(to right, #1890FF, #304156);
  position: relative;
  color: #fff;
  font-size: 16px;
}

.login #darkbannerwrap {
  background: url(../assets/images/aiwrap.png);
  width: 18px;
  height: 10px;
  margin: 0 0 20px -58px;
  position: relative;
}

.login input[type=text],
.login input[type=file],
.login input[type=password],
.login input[type=email],
.login select {
  border: 1px solid #DCDEE0;
  vertical-align: middle;
  border-radius: 3px;
  height: 50px;
  padding: 0px 16px;
  font-size: 14px;
  color: #555555;
  outline: none;
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.login input[type=text]:focus,
.login input[type=file]:focus,
.login input[type=password]:focus,
.login input[type=email]:focus,
.login select:focus {
  border: 1px solid #27A9E3;
}

.login input[type=submit],
.login input[type=button] {
  display: inline-block;
  padding: 12px 24px;
  margin: 0px;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  color: #ffffff;
  background-color: #304156;
  border-radius: 3px;
  border: none;
  -webkit-appearance: none;
  outline: none;
  width: 100%;
}

.login hr {
  background: #fff 0 0 no-repeat;
}

.login hr.hr15 {
  height: 15px;
  border: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
}

.login .qrcode{
  text-align: right;
}

.qrcode span{
  cursor: pointer;
}

.layui-btn {
    display: inline-block;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    padding: 0 18px;
    background-repeat: repeat-y;
    background-image: -moz-linear-gradient(to right, #1890FF, #304156);
    background-image: -webkit-linear-gradient(to right, #1890FF, #304156);
    background-image: -o-linear-gradient(to right, #1890FF, #304156);
    background-image: linear-gradient(to right, #1890FF, #304156);
    background-color: #304156;
    color: #fff;
    white-space: nowrap;
    text-align: center;
    border: none;
    border-radius: 2px;
    cursor: pointer;
    box-sizing: border-box;
}
</style>